export enum CommunityTabType {
  HIGHLIGHTS = 'highlights',
  STORIES = 'stories',
  BLOGS = 'blogs',
}
